<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="ts-space-y-3">
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">{{
              $t('deposit.transactionType')
            }}</label>
            <a-select
              v-model="model.tran_type_id"
              class="ts-w-full"
              :options="transaction_types"
              :disabled="true"
            ></a-select>
            <div class="validate" v-if="errors.has('tran_type_id')">
              {{ errors.first('tran_type_id') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div
              class="ts-bg-gray-100 ts-py-1 ts-px-2 ts-flex ts-items-center ts-justify-between ts-rounded-md"
            >
              <h4
                class="ts-text-sm ts-text-maincolor ts-font-semibold ts-uppercase ts-mt-2"
              >
                {{ $t('deposit.dealer') }}
              </h4>
              <h4 class="ts-text-red-600 ts-text-sm ts-mt-2">
                {{ main_balance }}
              </h4>
            </div>
            <div class="ts-space-y-3 ts-shadow-md ts-rounded-lg ts-p-3 ts-mt-3">
              <div class="ts-grid ts-grid-cols-3 ts-gap-2">
                <div class="ts-col-span-1 ts-text-right">
                  <label class="ts-text-xs required ts-mr-3">{{
                    $t('deposit.dealerName')
                  }}</label>
                </div>
                <div class="ts-col-span-2">
                  <a-select
                    v-model="model.dealer_id"
                    class="ts-w-full"
                    :options="dealerNameOption"
                    @change="onDealerChange"
                  ></a-select>
                  <div
                    class="validate ts-text-xs"
                    v-if="errors.has('dealer_id')"
                  >
                    {{ errors.first('dealer_id') }}
                  </div>
                </div>
                <div class="ts-col-span-1 ts-text-right">
                  <label class="ts-text-xs">{{
                    $t('deposit.dealerCode')
                  }}</label>
                </div>
                <div class="ts-col-span-2">
                  <input
                    type="text"
                    class="form-control ts-outline-none"
                    readonly
                    :value="dealer_info.dealer_code"
                  />
                </div>
                <div class="ts-col-span-1 ts-text-right">
                  <label class="ts-text-xs">{{
                    $t('deposit.idPassportNo')
                  }}</label>
                </div>
                <div class="ts-col-span-2">
                  <input
                    type="text"
                    readonly
                    class="form-control ts-outline-none"
                    :value="dealer_info.id_passport_no"
                  />
                </div>
                <div class="ts-col-span-1 ts-text-right">
                  <label class="ts-text-xs">{{ $t('deposit.contact') }}</label>
                </div>
                <div class="ts-col-span-2">
                  <input
                    type="text"
                    readonly
                    class="form-control ts-outline-none"
                    :value="
                      dealer_info.primary_contact +
                        (dealer_info.secondary_contact
                          ? '/' + dealer_info.secondary_contact
                          : '')
                    "
                  />
                </div>
                <div class="ts-col-span-1 ts-text-right">
                  <label class="ts-text-xs">{{ $t('deposit.address') }}</label>
                </div>
                <div class="ts-col-span-2">
                  <textarea
                    v-model="dealer_info.dealer_address"
                    rows="3"
                    class="form-control ts-outline-none"
                    readonly
                  ></textarea>
                </div>
                <div class="ts-col-span-1 ts-text-right">
                  <label class="ts-text-xs">{{
                    $t('deposit.topupCommissionRate')
                  }}</label>
                </div>
                <div class="ts-col-span-2">
                  <input
                    type="number"
                    step="any"
                    class="form-control ts-outline-none"
                    readonly
                    :value="dealer_info.topup_commission_rate"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <label class="ts-text-xs required">{{
              $t('deposit.amount')
            }}</label>
            <input
              type="number"
              step="any"
              class="form-control"
              v-model.number="model.amount"
            />
            <div class="validate ts-text-xs" v-if="errors.has('amount')">
              {{ errors.first('amount') }}
            </div>
          </div>
          <div class="col-md-6">
            <label class="ts-text-xs">{{ $t('deposit.totalDeposit') }}</label>
            <input
              type="number"
              step="any"
              class="form-control"
              readonly
              :value="totalAmount"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="ts-text-xs">{{ $t('deposit.description') }}</label>
            <textarea
              v-model="model.description"
              rows="3"
              class="form-control"
            ></textarea>
            <div class="validate ts-text-xs" v-if="errors.has('description')">
              {{ errors.first('description') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 ts-text-right ts-mt-3">
            <ts-button @click.prevent="$emit('cancel')">{{
              $t('cancel')
            }}</ts-button>
            <ts-button
              class="ts-ml-3"
              color="primary"
              :waiting="waiting"
              @click.prevent="onSave"
              >{{ $t('submit') }}</ts-button
            >
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'supperDepositForm',
  data() {
    return {
      loading: false,
      waiting: false,
      errors: new Errors(),
      dealers: [],
      transaction_types: [],
      main_balance: 0,
      dealer_info: {
        primary_contact: 0,
        secondary_contact: 0
      },
      model: {
        tran_type_id: 2,
        dealer_id: null,
        description: null,
        amount: 0
      }
    }
  },
  created() {
    this.fetchDealer()
  },
  computed: {
    totalAmount() {
      if (this.dealer_info.topup_commission_rate) {
        var comission =
          (this.dealer_info.topup_commission_rate / 100) * this.model.amount
        return parseFloat(comission) + this.model.amount
      }
      return 0
    },
    dealerNameOption() {
      return this.dealers.map(el => ({
        value: el.dealer_id,
        label: el.dealer_name
      }))
    }
  },
  methods: {
    ...mapActions('accounting/supperDeposit', [
      'getDealer',
      'getTransactionType',
      'store',
      'getCurrentBalance'
    ]),
    async fetchDealer() {
      this.loading = true
      await this.getDealer()
        .then(result => {
          this.dealers = result.data
        })
        .catch(err => {
          this.$toasted.error(err.message)
        })
      await this.getCurrentBalance()
        .then(result => {
          this.main_balance = result.data[0].main_balance
        })
        .catch(err => {
          this.$toasted.error(err.message)
        })
      await this.getTransactionType()
        .then(result => {
          this.transaction_types = result.data.map(el => ({
            value: el.tran_type_id,
            label: el.tran_type
          }))
        })
        .catch(err => {
          this.$toasted.error(err.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onDealerChange(dealer_id) {
      let result = this.dealers.filter(d => d.dealer_id == dealer_id)
      this.dealer_info = Object.assign({}, ...result)
    },
    onSave() {
      this.waiting = true
      this.store(this.model)
        .then(result => {
          this.$toasted.success(result.message)
          this.$emit('cancel')
        })
        .catch(err => {
          this.errors = new Errors(err.errors)
          this.$toasted.error(err.message)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  }
}
</script>
